@if (gridConfig.fields) {
  <dhs-data-grid [fields]="gridConfig.fields" [data]="{resource:dialogConfig.data.valueset}" [config]="gridConfig.config"  (editEllipseClick)="buttonAction($event)"></dhs-data-grid>
}

@if (valuesetDetailGrid.fields && valuesetDetailGrid.dataToShow) {
  <dhs-data-grid [fields]="valuesetDetailGrid.fields" [data]="valuesetDetailGrid.dataToShow" [config]="gridConfig.config" (onPageChanges)="onPageChanges($event)" (onLimitChange)="onLimitChange($event)"  (editEllipseClick)="buttonAction($event)"></dhs-data-grid>
}
